<script>
import MainMenuStudentView from '../../../shared/views/MainMenuStudentView';
import ListSimulatorExploreView from '../lists/ListSimulatorExploreView';
import PermissionHelper from '../../../../core/shared/helpers/PermissionHelper';

export default {
  name: 'ModuleSimulatorExploreView',
  components: {
    'main-menu-student-view': MainMenuStudentView,
    'list-simulators-explore-view': ListSimulatorExploreView,
  },
  data() {
    return {};
  },
  methods: {
    onCanShow(moduleName) {
      return PermissionHelper.canShow(moduleName);
    },
  },
};
</script>

<template>
  <div>
    <main-menu-student-view />
    <div class="wrapper">
      <div class="sa4d25">
        <div class="container-fluid">
          <div class="section3125">
            <!-- Encabezado de página Appmisionate -->
            <div class="stream_page_header">
              <div class="stream_header_left">
                <div class="stream_header_icon">
                  <i class="uil uil-file-check-alt" />
                </div>
                <div class="stream_header_text">
                  <h4 class="item_title">
                    Simuladores de Examen
                  </h4>
                  <p class="stream_header_subtitle">
                    Entrena con evaluaciones tipo admisión, cronómetro en tiempo real y retroalimentación de respuestas
                  </p>
                </div>
              </div>
              <div class="stream_header_right">
                <span class="stream_live_pill">
                  <i class="uil uil-stopwatch mr-1" /> Evaluaciones Oficiales
                </span>
              </div>
            </div>

            <!-- Contenido de simuladores -->
            <div class="la5lo1">
              <list-simulators-explore-view />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
